import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ButtonPrimary } from '@americanexpress/dls-react';

const getVal = require('lodash/get');

/**
 * returns Consent compoent
 * @param {*} props
 */
const Consent = ({
  fieldId,
  fieldLabel,
  cssProperties,
  isButtonShow,
  fileUploadInfo,
  isFormSubmission,
  fieldValidation,
  dynamicFieldValidation,
  formSubmissionPayload,
}) => {
  const [checked, setChecked] = useState(false);
  const buttonLabel = fieldLabel.buttonLabel ? fieldLabel.buttonLabel : 'Submit';
  const [isFileUploadRequired, setIsFileUploadRequired] = useState(false);

  useEffect(() => {
    setIsFileUploadRequired(fieldValidation && fieldValidation.isFileUploadRequired === false
      ? fieldValidation.isFileUploadRequired : true);
  }, []);

  /**
   * handle checkbox click
   */
  const handleCheck = () => {
    setChecked(!checked);
  };

  useEffect(() => {
    if (fileUploadInfo.length === 0) setChecked(false);
  }, [fileUploadInfo]);

  const evaluateDynamicValidationsFn = () => {
    if (dynamicFieldValidation && dynamicFieldValidation.isFileUploadRequired) {
      const obj = dynamicFieldValidation.isFileUploadRequired;

      const val = getVal(formSubmissionPayload, obj.propertyKey);

      setIsFileUploadRequired(obj.mapResponse[val] ? obj.mapResponse[val] : false);
    }
  };

  useEffect(() => {
    evaluateDynamicValidationsFn();
  }, [formSubmissionPayload]);

  return (
    <div className="consentWrapper col-md-10 col-md-offset-1 margin-2-t">
      <p className="label-3 margin-1-tb">{fieldLabel.label1}</p>
      <div className="checkbox">
        <input
          type="checkbox"
          id={fieldId}
          className={`form-control ${cssProperties.style}`}
          name={fieldId}
          value={checked}
          onChange={handleCheck}
          checked={checked}
        />
        <label className="label-3" htmlFor={fieldId}>{fieldLabel.label2}</label>
      </div>
      {fieldLabel && fieldLabel.disclamerText
        && <span className="body-3">{fieldLabel.disclamerText}</span>}

      {
        isButtonShow && (
          <div className="text-align-center margin-3-tb">
            <ButtonPrimary
              size="md"
              id="submit"
              type="submit"
              disabled={isFormSubmission || !(isFileUploadRequired
                ? checked && fileUploadInfo.length > 0
                : checked)}
            >
              {buttonLabel}
            </ButtonPrimary>
          </div>
        )
      }
    </div>
  );
};

Consent.propTypes = {
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  fieldId: PropTypes.string,
  isButtonShow: PropTypes.bool,
  fileUploadInfo: PropTypes.objectOf(PropTypes.shape),
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  isFormSubmission: PropTypes.bool,
  dynamicFieldValidation: PropTypes.objectOf(PropTypes.shape),
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
};

export default Consent;
